import { isNewGroupFilesEnabled } from '@ms/yammer-data/dist/domains/groupFiles/selectors';

import { useSelector } from '../useSelector';

type UseIsNewGroupFilesEnabled = () => ReturnType<typeof isNewGroupFilesEnabled>;
export const useIsNewGroupFilesEnabled: UseIsNewGroupFilesEnabled = () =>
  useSelector((state) => isNewGroupFilesEnabled(state));
